export default __webpack_public_path__ + "static/media/add2.bc6cb80a.png";